module.exports = __webpack_public_path__ + "static/img/home_2s.a4674a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_2s.jpg
// module id = Qbz/
// module chunks = 1